import * as AUTH_SERVICES from "api/services/auth/auth.services";
import Breadcrumbs from "components/breadcrumbs";
import { FC, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useGetProfileTeacherQuery } from "store/services/teacher/profileTeacher";

//!COMPONENTS
import { UserRoles } from "common/enums";
import * as appRoutes from "config/routes.config";
import { setSeeAvis, setSeeContributions, setSeePublications } from "store/auth/authSlice";
import AppScreen from "../ScreenWithSidebar";
import AboutProfileTeacher from "./components/about";
import HeaderProfileTeacher from "./components/header";

type Props = {
  displayBreadcrumbs?: boolean;
  displayButtonProfile?: boolean;
};

const ProfileTeacher: FC<Props> = ({

  displayBreadcrumbs = true,
  displayButtonProfile,
}) => {
  //!HOOKS
  const params = useParams<"id">();
  const { user, idTeacher, isLoggedIn, isAppInMaintenance } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const query = useMemo(() => {
    const profId = params.id ?? (user?.roles?.includes("teacher") ? user._id : undefined);
    const studId = user?._id ?? params.id;
    return { profId, studId };
  }, [params.id, user]);
  const { data, isLoading, isError } = useGetProfileTeacherQuery(query, {
    skip: !query.profId,
  });
  const isStudent = user?.roles?.includes(UserRoles.STUDENT);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1050);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1050);
  };
  window.addEventListener('resize', handleResize);

  const [teacherData, setTeacherData] = useState<any>();

  const getTeacherData = async (teacherId?: string) => {
    if (!teacherId) {
      return;
    }

    try {
      const response = await AUTH_SERVICES.getTeacherData(isLoggedIn ? user?._id : "62ceb218ce2dc5e1e1d9be89", teacherId);
      setTeacherData(response?.data);
    } catch (error: any) {
      console.error("Error fetching teacher data:", error);
    }
  };

  //!EFFECTS
  useEffect(() => {
    if (params.id) {
      getTeacherData(params.id);
    }
  }, [params]);

  useEffect(() => {
    if (user && !user.roles?.includes(UserRoles.STUDENT) && user._id) {
      getTeacherData(user._id);
    }
  }, [user]);

  useEffect(() => {
    setTimeout(() => {
      dispatch(setSeeAvis(false));
      dispatch(setSeePublications(false));
      dispatch(setSeeContributions(false));
    }, 1000);
  }, []);

  useEffect(() => {
    if (isAppInMaintenance) {
      navigate(appRoutes.MAINTENANCE);
    };
  }, [isAppInMaintenance]);

  return (
    <>
      {isMobile && user?.accountManaged !== "" && <div style={{ height: "0px", width: "100%" }}></div>}
      {displayBreadcrumbs && isStudent ? <Breadcrumbs isBack={true} isSearchProf={true} /> : <Breadcrumbs isBack={true} isProfil={true} />}
      <AppScreen>
        <HeaderProfileTeacher
          teacher={teacherData}
          displayButtonProfile={displayButtonProfile}
          alreadyFollowed={user?.roles?.includes(UserRoles.TEACHER) ? false : data?.data?.alreadyFollowd}
          followsNumber={user?.roles?.includes(UserRoles.TEACHER) ? "0" : data?.data?.followsNum}
        />
        <AboutProfileTeacher teacher={data?.data} />
      </AppScreen>
    </>
  );
};

export default ProfileTeacher;
